<template>
  <button class="AiHeaderBurgerFooterLink" @click="$emit('click')">
    <div class="AiHeaderBurgerFooterLink-labels">
      <ai-typo as="div" variant="overline-01" color="stratos-700">
        {{ subtitle }}
      </ai-typo>

      <ai-typo as="div" variant="paragraph-04-bold">
        {{ title }}
      </ai-typo>
    </div>

    <ai-icon name="chevron-right" color="gold-800" :size="12" />
  </button>
</template>

<script setup lang="ts">
import AiTypo from '../../atoms/AiTypo/AiTypo.vue';
import AiIcon from '../../atoms/AiIcon/AiIcon.vue';

type Props = {
  subtitle: string;
  title: string;
};

type Emits = {
  (event: 'click'): void;
};

defineProps<Props>();
defineEmits<Emits>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/colors';

.AiHeaderBurgerFooterLink {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: left;
  padding: constants.$padding-01 constants.$padding-02;
  background: colors.$gold-100;
  border-bottom: 1px solid colors.$gold-200;
}

.AiHeaderBurgerFooterLink-labels {
  text-transform: uppercase;
  flex-grow: 1;
}
</style>
